import { B300, N70 } from '@atlaskit/theme/colors';
import { REGULAR_FONT_WEIGHT, SEMI_BOLD_FONT_WEIGHT } from './constants';
export var getMarkerColor = function getMarkerColor(status) {
  switch (status) {
    case 'unvisited':
      return "var(--ds-icon-subtle, ".concat(N70, ")");
    case 'current':
    case 'visited':
    case 'disabled':
      return "var(--ds-icon-brand, ".concat(B300, ")");
    default:
      return;
  }
};
export var getTextColor = function getTextColor(status) {
  switch (status) {
    case 'unvisited':
      return 'subtlest';
    case 'current':
      return 'brand';
    case 'visited':
      return 'color.text';
    case 'disabled':
      return 'disabled';
    default:
      return;
  }
};
export var getFontWeight = function getFontWeight(status) {
  switch (status) {
    case 'unvisited':
      return REGULAR_FONT_WEIGHT;
    case 'current':
    case 'visited':
    case 'disabled':
      return SEMI_BOLD_FONT_WEIGHT;
    default:
      return undefined;
  }
};